import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { VerzendTarievenPrijzen } from '../dto/verzend-tarieven-prijzen';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class VerzendTarievenPrijzenService extends CrudService<VerzendTarievenPrijzen> {

    constructor(injector: Injector) { super(VerzendTarievenPrijzen, injector); }

}
